const fontsObj = {
  calibri: "Calibri",
  centurygothic: "Century Gothic",
  centurygothicbold: "Century Gothic Bold",
  freesans: "FreeSans",
  timesnewroman: "Times New Roman",
  timesnewromanbold: "Times New Roman Bold",
  tahoma: "Tahoma",
  montserrat: "Montserrat-Regular",
  montserratSemibold: "Montserrat-SemiBold",
  montserratBold: "Montserrat-Bold",
  montserratExtrabold: "Montserrat-ExtraBold",
};

export type Fonts = keyof typeof fontsObj;

export const FONTS_OPTIONS = Object.entries(fontsObj).map(([value, label]) => ({ value, label }));

export const previewFonts: Record<Fonts, { fontFamily: string; fontWeight: number }> = {
  calibri: { fontFamily: "Calibri", fontWeight: 400 },
  centurygothic: { fontFamily: "Century Gothic", fontWeight: 400 },
  centurygothicbold: { fontFamily: "Century Gothic", fontWeight: 700 },
  freesans: { fontFamily: "FreeSans", fontWeight: 400 },
  timesnewroman: { fontFamily: "Times New Roman", fontWeight: 400 },
  timesnewromanbold: { fontFamily: "Times New Roman", fontWeight: 700 },
  tahoma: { fontFamily: "Tahoma", fontWeight: 400 },
  montserrat: { fontFamily: "Montserrat", fontWeight: 400 },
  montserratSemibold: { fontFamily: "Montserrat", fontWeight: 600 },
  montserratBold: { fontFamily: "Montserrat", fontWeight: 700 },
  montserratExtrabold: { fontFamily: "Montserrat", fontWeight: 800 },
};
